import { NgModule } from '@angular/core';

import {
  Ng4FilesService,
  Ng4FilesUtilsService
} from './services';

import {
  Ng4FilesClickComponent,
  Ng4FilesDropComponent
} from './components';

/**
 * Author: Noraini A.Ghani
 * 
 * Date Created: July 24th 2018
 * 
 * Description: Module for File Upload Utility
 **/
@NgModule({
  declarations: [
    Ng4FilesClickComponent,
    Ng4FilesDropComponent
  ],
  exports: [
    Ng4FilesClickComponent,
    Ng4FilesDropComponent
  ],
  providers: [
    Ng4FilesService,
    Ng4FilesUtilsService
  ]
})
export class Ng4FilesModule {
  // todo: except exports Ng4FilesUtilsService
}



// WEBPACK FOOTER //
// ./src/app/ng4-files/ng4-files.module.ts